import {AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {Settings} from "~/app/core/model/settings";
import {Platform} from "@ionic/angular";
import {NavigationService} from "~/app/core/navigation.service";
import {CoreService} from "~/app/core/core.service";

// Imported in offer.module.ts
@Component({
    selector: " TopActionBar",
    templateUrl: "./top-action-bar.component.html",
    styleUrls: ["./top-action-bar.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class TopActionBarComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() title: string = "TEST";
    @Input() navButtonType: "drawer" | "back" | "none";

    @Input() actionBarColor: string = null;
    @Input() actionBarTextColor: string = null;

    prefixTitle: string = "";

    private loadedSettings: Settings;

    constructor(
        private readonly platform: Platform,
        private readonly nav: NavigationService,
        private readonly cd: ChangeDetectorRef,
        readonly core: CoreService
    ) {
        core.settings.observeSettings().subscribe((settings) => {
            this.loadedSettings = settings;
            this.initActionBar();
        });
    }

    ngOnInit(): void {
        // nothing
    }

    ngOnDestroy(): void {
        // nothing
    }

    ngAfterViewInit(): void {
        // nothing
    }

    onTapNav() {
        if (this.navButtonType === "back") {
            this.nav.navBack();
        }
    }

    private initActionBar() {
        if (this.loadedSettings.showEnvironmentHeader) {
            if (this.loadedSettings.env !== "prod") {
                if (this.loadedSettings.testable) {
                    this.actionBarColor = 'rgba(132, 10, 15, 255)';
                    this.actionBarTextColor = 'rgba(255, 255, 255, 255)';
                    if (this.loadedSettings.testing) {
                        this.actionBarColor = 'rgba(0, 0, 0, 255)';
                    }
                }
            } else {
                this.actionBarColor = null;
                this.actionBarTextColor = null;
            }

            if (this.loadedSettings.env === "prod") {
                // don't change action bar
                this.prefixTitle = "";
            } else if (this.loadedSettings.env === "test") {
                this.prefixTitle = "TEST - ";
            } else if (this.loadedSettings.env === "local") {
                this.prefixTitle = "LOCAL - ";
            }
        }
        this.cd.markForCheck();
    }
}
